import { scan } from "react-scan"; // import this BEFORE react
import React from "react";
import ReactDOM from "react-dom/client";
import "@/css/components.css";
import "@/i18n";
import "@/lib/pdfConfig";
import Application from "./containers/application";
import * as Sentry from "@sentry/react";
import appConfiguration from "@/components/cfg/AppCfg";
import { SENTRY_IGNORE_ERRORS } from "@/sentryIgnoreErrors";
import { createServices, ServicesProvider } from "@/core/services";
import { ConfigProvider } from "@/core/config";
import { DefaultFeatureFlagService } from "@/core/features";

const {
  VITE_DOCUMENT_ENV,
  VITE_DOCUMENT_TITLE,
  VITE_REACT_SCAN,
  VITE_SENTRY_RELEASE,
} = import.meta.env;

Sentry.init({
  dsn: "https://b76048895c1e307cbd6667a270356579@o4510947314827264.ingest.de.sentry.io/4510947323412560",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  environment: appConfiguration.sentryEnv,
  ignoreErrors: SENTRY_IGNORE_ERRORS,
  release: VITE_SENTRY_RELEASE,
});

scan({
  enabled: VITE_REACT_SCAN === "true",
});

document.title = VITE_DOCUMENT_ENV
  ? `(${VITE_DOCUMENT_ENV}) ${VITE_DOCUMENT_TITLE}`
  : VITE_DOCUMENT_TITLE;

if (import.meta.env.VITE_PLAYWRIGHT === "true") {
  import("@/e2e").then(({ e2e }) => {
    (window as unknown as { e2e: typeof e2e }).e2e = e2e;
  });
}

const element = document.getElementById("root");

if (element) {
  const root = ReactDOM.createRoot(element);
  const services = createServices();
  const featureFlagService = new DefaultFeatureFlagService();

  root.render(
    <React.StrictMode>
      <ConfigProvider featureFlagService={featureFlagService}>
        <ServicesProvider services={services}>
          <Application />
        </ServicesProvider>
      </ConfigProvider>
    </React.StrictMode>,
  );
}
